// @flow
import * as React from "react";
import { ProgressBar } from "primereact/progressbar";
import moment from "moment";
import { Button, FormGroup, Spinner } from "reactstrap";
import { uploadFile } from '../api/files'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FileUpload } from 'primereact/fileupload';

class Camera extends React.Component {
    componentWillMount() {
        const { video } = this.props;
        if (navigator.mediaDevices) {
            navigator.mediaDevices
                .getUserMedia({ video })
                .then(mediaStream => {
                    this.setState({ mediaStream });
                    this.video.srcObject = mediaStream;
                    this.video.play();
                })
                .catch(error => error);
        }
    }

    componentWillUnmount() {
        this.video.pause();
        this.state.mediaStream.getTracks()[0].stop();
    }

    capture() {
        const mediaStreamTrack = this.state.mediaStream.getVideoTracks()[0];
        const imageCapture = new window.ImageCapture(mediaStreamTrack);

        return imageCapture.takePhoto();
    }

    pause() {
        this.video.pause();
    }

    resume() {
        this.video.play();
    }

    applyFilter(filter) {
        this.video.style.webkitFilter = filter;
    }

    render() {
        return (
            <div style={this.props.style || undefined} className="piramis-cam">
                {this.props.children}
                <video
                    onClick={e => {
                        this.props.onClick && this.props.onClick(e);
                    }}
                    style={styles.base}
                    ref={video => {
                        this.video = video;
                    }}
                />
            </div>
        );
    }
}

Camera.defaultProps = {
    video: true,
    children: null
};
const styles = {
    base: {
        width: "100%",
        height: "100%"
    }
};

let camera;

export default function CameraUploader(props) {
    const [loading, setLoading] = React.useState(false);
    const [opened, setOpened] = React.useState(false);
    const [uploading, setUpLoading] = React.useState(false);

    async function takePicture() {
        setLoading(true);
        try {
            const blob = await camera.capture();
            camera.pause();
            const filename = prompt("Inserire il nome del file");
            if (!filename) return;
            const file = await uploadFile(
                `${filename}-${moment().unix()}.jpeg`,
                blob
            );
            props.onFileUploaded(file);
        } finally {
            camera && camera.resume();
            setLoading(false);
        }
    }

    async function selectedFile(event) {

        setUpLoading(true);
        try {

            const filename = event.files[0].name;
            const blob = event.files[0];

            if (!filename) return;

            const file = await uploadFile(
                `${filename}`,
                blob
            );
            props.onFileUploaded(file);
        } finally {
            setUpLoading(false);
        }

    }

    return (
        <React.Fragment>
            {opened && (
                <div
                    style={{ position: "fixed", top: 0, bottom: 0, right: 0, left: 0, backgroundColor: "#000", zIndex: '1500' }}
                >
                    <div style={{ position: "relative" }}>
                        {loading && <ProgressBar mode="indeterminate" />}
                        <Camera
                            onClick={() => null}
                            ref={cam => {
                                if (cam) camera = cam;
                            }}
                        >
                            <Button
                                disabled={loading}
                                onClick={takePicture}
                                style={{
                                    width: "20%",
                                    position: "fixed",
                                    top: "25px",
                                    zIndex: 2000,
                                    left: "50%",
                                    transform: "translate(-50%,0)"
                                }}
                                color="success"
                            >
                                <FontAwesomeIcon icon="camera" />
                            </Button>

                            <Button
                                disabled={loading}
                                onClick={() => setOpened(false)}
                                style={{
                                    width: "20%",
                                    position: "fixed",
                                    zIndex: 2000,
                                    left: "50%",
                                    bottom: "25px",
                                    transform: "translate(-50%,0)"
                                }}
                                color="danger"
                            >
                                <FontAwesomeIcon icon="power-off" />
                            </Button>
                        </Camera>
                    </div>
                </div>
            )}

            <Button className="mr-2"
                style={props.style}
                tooltip={props.tooltip}
                color="warning"
                onClick={() => setOpened(true)}
            >
                <FontAwesomeIcon icon="camera" /> Cattura immagine
            </Button>

            <FormGroup className="float-left">
                <FileUpload
                    mode="basic"
                    name="demo[]"
                    url=""
                    accept="image/*|.pdf|.doc"
                    maxFileSize={1000000}
                    onUpload={null}
                    chooseLabel="Allega documento"
                    onSelect={(event) => selectedFile(event)}
                    auto={true}
                />
                {uploading && (
                    <p>
                        <Spinner /> Caricamento file in corso...
                    </p>
                )}
            </FormGroup>

        </React.Fragment>
    );
}
